import { ref, computed } from "vue";
import { useProfileStore } from "@/stores/profileStore";
import { commonLabels, profileLabels } from "@/utils/label";
import { deleteAccountSvg } from "@/utils/commonSvg";

export function useSubscriptionLogic(onSuccess) {
  const profileStore = useProfileStore();

  const isConfirmSubscriptionDialogOpen = ref(false);
  const selectedPlan = ref(null);
  const isMobileSubscription = computed(() => window.innerWidth <= 1024); // Local responsive check for dialog

  // Handle open confirm Subscription dialog
  const openConfirmSubscription = (plan) => {
    selectedPlan.value = plan;
    isConfirmSubscriptionDialogOpen.value = true;
  };

  // Start the subscription
  const startSubscription = async () => {
    try {
      const data = {
        subscriptionPlanId: selectedPlan.value.id || 0,
      };
      await profileStore.startSubscription(data);
      if (onSuccess) onSuccess();
      isConfirmSubscriptionDialogOpen.value = false;
      profileStore.isSubscriptionModalOpen = false;
    } catch (error) {
      console.error("An error occurred while start subscription:", error);
      throw error; // Re-throw to allow component to handle if needed
    }
  };

  // Handle confirmation of Subscription dialog subscribe action
  const onConfirmSubscriptionDialogOk = async () => {
    await startSubscription();
  };

  // Handle confirmation of Subscription dialog cancel action
  const onConfirmSubscriptionDialogCancel = () => {
    selectedPlan.value = null;
    isConfirmSubscriptionDialogOpen.value = false;
    profileStore.isSubscriptionModalOpen = false;
  };

  // Confirmation dialog configuration for Subscription
  const confirmSubscriptionDialogProps = computed(() => {
    return {
      title: profileLabels.confirmSubscriptionTitle,
      subtitle: profileLabels.confirmSubscriptionSubtitle,
      okBtnText: profileLabels.confirmSubscriptionBtn,
      cancelBtnText: commonLabels.cancel,
      svg: isMobileSubscription.value
        ? deleteAccountSvg({ width: "48", height: "49" })
        : deleteAccountSvg(),
      svgStyle: {
        ...(isMobileSubscription.value ? { height: "64px", width: "64px" } : {}),
        background:
          "linear-gradient(0deg, #FFEAE1, #FFEAE1), linear-gradient(315deg, rgba(251, 143, 0, 0) 11.89%, rgba(251, 143, 0, 0.2) 86.59%)",
      },
      subtitleClass: "!text-alert", // Alert styling for reset action
      error: profileStore.errorMessage,
      loading: profileStore.loading,
      dialogClass:
        "!w-[95%] sm:!w-[90%] md:!w-[80%] lg:!w-[70%] xl:!w-[60%] max-w-[1051px] h-[80vh] sm:h-[85vh] md:h-[90vh] max-h-[694px] reset-dialog-mobile-margin",
    };
  });

  return {
    isConfirmSubscriptionDialogOpen,
    selectedPlan,
    openConfirmSubscription,
    startSubscription,
    onConfirmSubscriptionDialogOk,
    onConfirmSubscriptionDialogCancel,
    confirmSubscriptionDialogProps,
  };
}
